/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_No_Client_TitleInputs */

const en_portal_no_client_title = /** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a client to see their portal`)
};

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const ar_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const he_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const ur_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const es_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const fr_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const de_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const pt_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const hi_portal_no_client_title = en_portal_no_client_title;

/** @type {(inputs: Portal_No_Client_TitleInputs) => LocalizedString} */
const bn_portal_no_client_title = en_portal_no_client_title;

/**
* | output |
* | --- |
* | "Pick a client to see their portal" |
*
* @param {Portal_No_Client_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_no_client_title = /** @type {((inputs?: Portal_No_Client_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_No_Client_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_no_client_title(inputs)
	if (locale === "he") return he_portal_no_client_title(inputs)
	if (locale === "ur") return ur_portal_no_client_title(inputs)
	if (locale === "es") return es_portal_no_client_title(inputs)
	if (locale === "fr") return fr_portal_no_client_title(inputs)
	if (locale === "de") return de_portal_no_client_title(inputs)
	if (locale === "pt") return pt_portal_no_client_title(inputs)
	if (locale === "hi") return hi_portal_no_client_title(inputs)
	if (locale === "bn") return bn_portal_no_client_title(inputs)
	return /** @type {LocalizedString} */ ("Pick a client to see their portal")
});